import {Link} from 'react-router-dom';
import React, {useEffect} from 'react';
import { useStoreActions, useStoreState } from "easy-peasy";


function PreviewCard(props) {
  const is_logged_in = useStoreState(state => state.is_logged_in);
  const get_preview_cards = useStoreActions(state => state.preview_cards.getPreviewCards);
  const setAsDefault = useStoreActions(state => state.preview_cards.setAsDefault);
  const domain = useStoreState(state => state.current_domain);

  useEffect(() => {
  }, [props]);

  const setDefault = (e) => {
      e.preventDefault()
      if (is_logged_in) {
        setAsDefault({domain: domain.domain, card_id: props.preview_card.id}).then(() => {
            get_preview_cards(domain.domain);
        });
      }
  };

  return (
    <tr className="align-middle">
        <td>{ props.preview_card.is_default ? "*" : (
            <a href="/make_default" onClick={setDefault}>Make default</a>
        ) }</td>
        <td><img alt={props.preview_card.name} height="30" src={ props.preview_card.image_url }/></td>
        <td>{ props.preview_card.name }</td>
        <td>{ props.preview_card.title }</td>
        <td>{ props.preview_card.description }</td>
        <td><Link to={"/preview_card/" + props.preview_card.id}>Edit</Link></td>
    </tr>
  );
}

export default PreviewCard;
